import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Senior perf: avoid re-fetching on every focus / mount; keep data warm
        // between navigations so returning to a page is instant.
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Preload route chunks + loaders on link hover/touchstart for instant nav.
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPreloadGcTime: 30_000,
    defaultPendingMs: 200,
    defaultPendingMinMs: 300,
  });

  return router;
};
